/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type RoutePlanStepEnum =
  (typeof RoutePlanStepEnum)[keyof typeof RoutePlanStepEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoutePlanStepEnum = {
  Pool: 0,
  Chains: 1,
  Assignment: 2,
  DriverSwaps: 3,
  Gaps: 4,
  ReturnLegRepair: 5,
  Classification: 6,
  ShortDayMerge: 7,
  CustomerRebooking: 8,
  IdleWaitRepair: 9,
  FreedFieldTesterSwap: 10,
} as const;
